import { Component, Inject, Injector } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BasePageComponent } from '../base.page';
import { localizationKeys } from './../../utils/localizationKeys';

@Component({
    selector: 'app-popup-component',
    templateUrl: './popUp.html',
})
export class PopUpComponent extends BasePageComponent {
    localizationKeys = localizationKeys;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private injector: Injector) {
        super(injector);
    }
}
